@if (mode === "icon") {
    @if (meters > 0) {
        <h-shop-info-title [headerLevelShopTitle]="headerLevelShopTitle + 1" [isScreenReaderOnly]="true">
            <ng-container i18n="@@page-hermes-product-locator-details-distance"> Distance </ng-container>
        </h-shop-info-title>

        <a
            class="icon-mode"
            i18n-title="@@hermes.accessibility.get-direction-title"
            title="Get directions (new window)"
            data-testid="shop-distance-link"
            [attr.aria-labelledby]="shopNameId + ' ' + directionInMetersId + ' ' + directionTextLinkId"
            [href]="directionUrl"
            target="_blank"
            rel="noopener noreferrer"
            (click)="shopInfoDirectionEvents.emit('direction')">
            <h-svg-icon [name]="'arrow-angle'" class="svg-get-direction"> </h-svg-icon>
            <span hSrOnlyNoSnippet [id]="directionTextLinkId" i18n="@@hermes.accessibility.get-direction-title">
                Get directions (new window)
            </span>
        </a>

        <p class="icon-mode-meters paragraph-small" [id]="directionInMetersId" data-testid="shop-distance">
            {{ meters | distanceFormatter }}
            @if (isCloserThan1Km(meters)) {
                <ng-container i18n="@@hermes-global-translations.item.m"> m </ng-container>
            }
            @if (!isCloserThan1Km(meters)) {
                <ng-container i18n="@@hermes-global-translations.item.km"> km </ng-container>
            }
        </p>
    }
} @else {
    <div class="text-mode-wrapper">
        <a
            class="text-mode paragraph-small"
            i18n-title="@@hermes.accessibility.get-direction-title"
            title="@@hermes.accessibility.get-direction-title"
            [href]="directionUrl"
            target="_blank"
            rel="noopener noreferrer"
            (click)="shopInfoDirectionEvents.emit('direction')"
            i18n="@@hermes-global-translations.get-directions">
            Get directions
        </a>
        <h-svg-icon [name]="'arrow-angle'" class="svg-get-direction"> </h-svg-icon>
    </div>
}
